import { useParams } from "react-router-dom";
import { ExoProject } from "../../components/exo/ExoProject";

export const ProjectManagement = () => {
  const { id } = useParams();
  return <ExoProject projectId={id} />;
};
